import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function AcceptableUse() {
  return (
    <LegalLayout title="Acceptable Use Policy" updated="July 12, 2026" testid="acceptable-use-page">
      <p>
        This Acceptable Use Policy governs how you may use Learn Me (LearnMeAI). By using the platform
        you agree to follow these rules. They exist to keep Learn Me safe, lawful, and beneficial for
        everyone.
      </p>

      <LegalSection heading="1. Our mission" testid="aup-mission">
        <p>LearnMeAI exists to make learning easy, accessible, and beneficial for everyone.</p>
      </LegalSection>

      <LegalSection heading="2. Family-friendly learning standard" testid="aup-family-friendly">
        <p>
          LearnMeAI is intended to be a <strong>family-friendly platform suitable for learners of all
          ages</strong>. You may not create, request, distribute, or consume content that is harmful,
          dangerous, illegal, sexually explicit, violent, harassing, hateful, or exploitative.
        </p>
      </LegalSection>

      <LegalSection heading="3. Prohibited content and activities" testid="aup-prohibited">
        <p>The following content and activities are strictly prohibited on Learn Me:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Bombs, explosives, weapons, or chemical or biological weapons.</li>
          <li>Content facilitating physical harm, self-harm, violence, torture, or animal abuse.</li>
          <li>Criminal activities, fraud, scams, identity theft, money laundering, or extortion.</li>
          <li>Malware, ransomware, phishing, credential theft, or unauthorized access.</li>
          <li>Illegal drug production or trafficking.</li>
          <li>Pornographic or sexually explicit content.</li>
          <li>Hate, harassment, discrimination, or extremist content.</li>
          <li>Misinformation, impersonation, or fraudulent certifications.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="4. Child safety" testid="aup-child-safety">
        <p>
          LearnMeAI <strong>strictly prohibits child exploitation, grooming, or sexualized content
          involving minors</strong>. There are no exceptions to this rule.
        </p>
      </LegalSection>

      <LegalSection heading="5. Educational use encouraged" testid="aup-encouraged">
        <p>
          Learn Me is built for genuine learning. Encouraged topics include school subjects, science,
          mathematics, history, professional development, business skills, leadership, personal growth,
          technical training, compliance training, health and wellness education, hobbies, animal care,
          parenting, financial literacy, and career development.
        </p>
      </LegalSection>

      <LegalSection heading="6. Commercial content standards" testid="aup-commercial">
        <p>
          Organizations using Learn Me are responsible for ensuring their content is accurate, lawful,
          non-discriminatory, workplace-appropriate, and relevant.
        </p>
      </LegalSection>

      <LegalSection heading="7. Content review and enforcement" testid="aup-enforcement">
        <p>
          To uphold this policy, LearnMeAI may review content, block prohibited topics, remove content,
          restrict access, suspend accounts, or terminate accounts.
        </p>
      </LegalSection>

      <LegalSection heading="8. AI moderation" testid="aup-ai-moderation">
        <p>
          When a requested topic could reasonably enable physical harm, criminal activity, cyber abuse,
          sexual exploitation, hate, harassment, or other unsafe behavior, LearnMeAI will refuse the
          request and redirect the learner toward educational, legal, ethical, or safety-focused
          information.
        </p>
      </LegalSection>

      <LegalSection heading="9. Guiding principle" testid="aup-principle">
        <p>
          LearnMeAI exists to help people learn, grow, and improve themselves. If a topic is intended to
          harm people, violate laws, exploit others, create unsafe situations, or undermine a
          family-friendly environment, it does not belong on LearnMeAI.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
